// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getPageLinkByPageType, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { activeStateTrue } from "@stanion/App/Widgets/SearchEngineOptimization/ActiveState";
import { SeoAppProps, SeoHandlerProps } from "@stanion/App/Widgets/SearchEngineOptimization/Type";
import { ContactPage, WithContext } from "@stanion/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaContactPage = ({ state, fields, url }: SeoAppProps): WithContext<ContactPage> => {
    const contactUsUrl = getPageLinkByPageType(state, "ContactUsPage")?.url;
    const link = useGetLink(fields.contactUs)?.url;
    const contactLink = link || contactUsUrl || "";
    const contactUrl = `${url}${contactLink}`;

    return {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: fields.organizationName || state.context.website.name,
        description: fields.description,
        url: contactUrl,
        image: fields.logoUrl,
    };
};

export default {
    isActivate: activeStateTrue,
    buildSchema: loadSchemaContactPage,
} as SeoHandlerProps;
